import { Fragment, useContext, useEffect, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";

import UserContext from "../../store/user-context";
import { Alert, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";
import AuthModuleInvalidFlowsTable from "../../components/Tables/AuthModuleInvalidFlowsTable";
import {
  createQueryStringFromFilters,
  sendApiRequest,
} from "../../services/Base/base-service";
import Filters from "../../components/Header/Filters";

const AuthModuleInvalidFlows = () => {
  const [flows, setFlows] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const getFilters = (filters) => {
    setFilters(filters);
  };

  useEffect(() => {
    if (filters !== null) {
      setTimeout(() => {
        getFlows();
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const getFlows = () => {
    setIsLoading(true);
    setError(null);
    setTimeout(() => {
      sendApiRequest(
        "StagedFlows/GetAllStagedFlowsNotValid",
        "GET",
        true,
        filters,
        signIn,
        signOut,
        navigate,
        createQueryStringFromFilters,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setError(null);
            setFlows(response.data.stagedFlowsNotValid);
            setIsLoading(false);
          }
        }
      });
    }, 500);
  };

  return (
    <Fragment>
      <Filters page="authModuleFlowsNotValid" getFilters={getFilters} />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <AuthModuleInvalidFlowsTable
            items={flows}
            columns={[
              {
                name: "Data di predisposizione",
                type: "date",
                sortable: true,
                value: "predispositionDate",
              },
              {
                name: "Nome del flusso",
                type: "string",
                sortable: true,
                value: "name",
              },
              {
                name: "Tipologia",
                type: "string",
                sortable: false,
                value: "clientCodeName",
              },
              {
                name: "Formato",
                type: "string",
                sortable: false,
                value: "format",
              },
              {
                name: "Stato",
                type: "string",
                sortable: false,
                value: "status",
              },
              {
                name: "Azioni",
                type: null,
                sortable: false,
                value: "",
              },
            ]}
            setFlows={setFlows}
            setIsLoading={setIsLoading}
            getFlows={getFlows}
          />
        )}
      </Section>
      <Footer />
    </Fragment>
  );
};

export default AuthModuleInvalidFlows;
